module.exports = __webpack_public_path__ + "6fcbaaca1103ecdb6192de245c5226fa.MP3";